<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="cover" id="cvi">
<div class="cover">
<p class="fig"><img alt="Cover Page for New Orleans and the Creation of Transatlantic Opera, 1819–1859" role="doc-cover" src="images/chi-Bentley-cover.jpg"/></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-bentley-0001.vue?a7eb714c